<template>
  <div class="row">
    <div class="col-12">
      <breadcrumb :page="page" @page-change="page = $event" />
    </div>
    <div class="col-12 flip-cards-container">
      <squareOption
        v-for="(option, index) in optionList"
        :key="index"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import squareOption from '@/components/common/menu/SquareOption';
import breadcrumb from '@/components/common/page/TitleBreadcrumb';

export default {
  components: {
    squareOption,
    breadcrumb,
  },
  computed: {
    hasSelectedStudent() {
      return store.getters.IsValidSelectedStudent;
    },
    optionList() {
      return store.getters['$_user/getSiteMap']
        .find((x) => x.title == 'Becas')
        .children.map((item) => ({
          title: item.title,
          description: item.description,
          detail: item.detail,
          icon: item.iconClasses,
          mainImage: item.mainImagePath,
          hoverImage: item.mainImageHoverPath,
          needSelectedStudent: item.needSelectedStudent,
          route: item.navigationPath,
          trackingFlag: item.trackingFlag
        }));
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-book',
        title: 'Becas',
        routes: ['Inicio', 'Becas'],
      },
    };
  },
};
</script>
<style scoped>
.flip-cards-container {
  display: flex;
  flex-wrap: wrap;
}

.flip-cards-container > div {
  min-height: 200px;
  min-width: 200px;
}
</style>
